projects = {
  items: [],
  countries: [],
  locale: "",
  initialLimit: 15,
  loadMoreStep: 9,
  currentLimit: 0,
  filteredItems: [],
};

projects.index = {
  init: function () {
    projects.items = window.projectsFromView;
	  projects.countries = window.countriesFromView;

    projects.index.applyFilters(true); // Inicialmente, aplicar filtros (vacíos) para establecer filteredItems
    projects.index.binds();
    projects.index.addLoadMoreButton(); // Añadir el botón

  },

  binds: function () {
    // debounce helper
    const debounce = (fn, wait) => {
      let t;
      return function () {
        clearTimeout(t);
        const args = arguments;
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };

    $(".js-filter-name").on(
      "input",
      debounce(function () {
        //projects.index.applyFilters();
      }, 250)
    );

    $(".js-filter-country").on("change", function () {
      //projects.index.applyFilters();
    });

    $(".js-filter-btn").on("click", function () {
      projects.index.applyFilters();
    });

    // Enter key in search input triggers filter
    $(document).on("keydown", ".js-filter-name", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        projects.index.applyFilters();
      }
    });

    // Evento para el botón 'Cargar Más'
    $(document).on("click", ".js-load-more-btn", function (e) {
      e.preventDefault(); // Prevenir el salto a '#'
      projects.index.loadMoreProjects();
    });
  },

  renderAll: function () {
    // initial render: show all projects
    this.renderProjects(projects.items);
  },

  // obtiene nombre localizado
  getProjectName: function (project) {
    if (!project) return "";
    const locale = projects.locale || "es";
    if (project.name) {
      if (typeof project.name === "string") return project.name;
      if (project.name[locale]) return project.name[locale];
      // fallback to first available value
      const vals = Object.values(project.name);
      if (vals.length) return vals[0];
    }
    return "";
  },

  getCountryName: function (countryId) {
    const c = (projects.countries || []).find(
      (x) => Number(x.id) === Number(countryId)
    );
    return c ? c.name : "";
  },

  applyFilters: function (initialCall = false) {
    const nameQ = ($(".js-filter-name").val() || "").trim().toLowerCase();
    const countryQ = ($(".js-filter-country").val() || "").trim();

    console.log("applyFilters", nameQ, countryQ, projects.items);

    const filtered = projects.items.filter((p) => {
      if (countryQ) {
        if (!p.country_id || String(p.country_id) !== String(countryQ))
          return false;
      }

	  if (nameQ) {
        const pname = (this.getProjectName(p) || "").toLowerCase();
        if (pname.indexOf(nameQ) !== -1) return true;

		if (p.name && typeof p.name === "object") {
          for (const v of Object.values(p.name)) {
            if (String(v).toLowerCase().indexOf(nameQ) !== -1) return true;
          }
        }
        return false;
      }
      return true;
    });

    projects.filteredItems = filtered;
    projects.currentLimit = projects.initialLimit;

    this.renderProjects(projects.filteredItems.slice(0, projects.currentLimit));

    this.updateLoadMoreButtonState();
  },

  loadMoreProjects: function () {
    projects.currentLimit += projects.loadMoreStep;

    this.renderProjects(projects.filteredItems.slice(0, projects.currentLimit));

    this.updateLoadMoreButtonState();
  },

  updateLoadMoreButtonState: function () {
    const totalFiltered = projects.filteredItems.length;
    const $btnContainer = $(".js-load-more-btn").closest("div");

    if (projects.currentLimit >= totalFiltered) {
      $btnContainer.hide();
    } else {
      $btnContainer.show();
    }
  },

  renderProjects: function (items) {
    const $container = $(".js-projectsCarousel").first();
    $container.empty();

    const pattern = $(".js-patternProject").first();
    if (!pattern.length) return;

    if (!items || !items.length) {
      $container.append('<div class="no-results">No hay proyectos</div>');
      return;
    }

    items.forEach((p) => {
      const $clone = pattern.clone();
      $clone.removeClass("js-patternProject").show();

      const $content = $clone.find(".project-content");
      const name = this.getProjectName(p) || "";
      const countryName = this.getCountryName(p.country_id) || "";

      let subtitleText = countryName; 

    if (p.projectCategory && p.projectCategory.toLowerCase().includes('formation')) {

        if (p.projectCategory == 'formation_university')
          subtitleText = window.formation_university;
        else if (p.projectCategory == 'formation_professional')
          subtitleText = window.formation_professional;
    }

	  $clone.attr('href', p.url);
      $content.attr("data-country", p.country_id || "");
      $content.attr("data-name", name);
      $content.attr("data-id", p.id || "");

      const imgSrc = p.image ? ("/storage/media/" + p.image).replace("//", "/") : "";
      $clone.find("img").attr("src", imgSrc).attr("alt", name);
      $clone.find(".project-title").text(name);
      $clone.find(".project-subtitle").text(subtitleText);

      $container.append($clone);
    });
  },
};

projects.detail = {
  init: function () {
    projects.detail.loadProjectDetailCarousel();
  },
  loadProjectDetailCarousel: function () {
    let $projectDetailCarousel = $(".js-projectDetailCarousel");

    $projectDetailCarousel.on("init", function () {
      $projectDetailCarousel.addClass("isLoaded");
    });

    $projectDetailCarousel.slick({
      arrows: true,
      dots: false,
      infinite: true,
      speed: 400,
      fade: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      appendArrows: ".js-projectDetailArrows",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 940,
          settings: {
            slidesToShow: 1.03,
            slidesToScroll: 1
          }
        },
      ]
    });
  },
  binds: function () {},
};

projects.ods = {
	init: function () {

	},
	showOdsPopup: function () {
		let $popup = $('.ods-popup');

		console.log('showOdsPopup', $popup);

		$popup.find('.ods-popup-image').attr('src', $(this).find('.ods-image').attr('src'))
		$popup.find('.ods-popup-content').html($(this).find('.ods-descr').val())

		$popup.removeClass('hidden');
	},
	closeOdsPopup: function () {
		let $popup = $('.ods-popup');
		$popup.addClass('hidden');
	},
  hoverOds: function(){
    let $parent = $('.section-ods');
    $parent.find('.ods-container').css('opacity', 0.5);
    $(this).css('opacity', 1);
    
  },
  nonHoverOds: function(){
    let $parent = $('.section-ods');
    $parent.find('.ods-container').css('opacity', 1);    
  },
	binds: function () {
		console.log('binds ods');
		$('.ods-container').on('click', this.showOdsPopup)
		$('.ods-popup-close').on('click', this.closeOdsPopup)
    $('.ods-container').on('mouseenter', this.hoverOds)
    $('.ods-container').on('mouseleave', this.nonHoverOds)
	}
}

projects.init = function () {
  if ($('.projects-wrapper').length > 0) {
    projects.index.init();
  }
  projects.detail.init();
  	projects.ods.init();

};

projects.binds = function () {
  if ($('.projects-wrapper').length > 0) {
    projects.index.binds();
  }
	projects.ods.binds();

  projects.detail.binds();
};

$(document).ready(function () {
  projects.binds();
  projects.init();
});
